import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Question } from "@phosphor-icons/react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import api from "@/lib/api";

export const FaqSection = ({ country }) => {
  const [faq, setFaq] = useState([]);

  useEffect(() => {
    // Ignore stale responses (e.g. initial "all" request resolving after a ?country= deep-link request)
    let active = true;
    api
      .get("/faq", { params: { country } })
      .then((r) => { if (active) setFaq(r.data.faq); })
      .catch(() => {});
    return () => { active = false; };
  }, [country]);

  if (!faq.length) return null;
  const place = country && country !== "all" ? country : null;
  const ld = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faq.map((f) => ({ "@type": "Question", name: f.question, acceptedAnswer: { "@type": "Answer", text: f.answer } })),
  };

  return (
    <section data-testid="faq-section" className="border-t border-white/10 bg-[#0d1020]">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(ld)}</script>
      </Helmet>
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-16 sm:px-8 lg:grid-cols-[1fr_2fr]">
        <div>
          <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.16em] text-blue-400">
            <Question size={14} weight="fill" /> FAQ
          </span>
          <h2 className="mt-3 font-display text-3xl font-extrabold tracking-tight text-white">
            Franchise expos{place ? ` in ${place}` : ""}, answered
          </h2>
          <p className="mt-3 text-sm text-slate-400">Live answers drawn from the directory — updated as shows are added.</p>
        </div>
        <Accordion type="single" collapsible className="w-full">
          {faq.map((f, i) => (
            <AccordionItem key={f.question} value={`q${i}`} className="border-white/10">
              <AccordionTrigger data-testid={`faq-question-${i}`} className="text-left text-base font-semibold text-white hover:no-underline">
                {f.question}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-answer-${i}`} className="text-sm leading-relaxed text-slate-400">
                {f.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
